const raManagementPlanTags = (labelEvent) => ({
    management_plan_total_want: {
        categoriaEvento: "robo-advisor/plan-gestion",
        accionEvento: "clickLink",
        etiquetaEvento: labelEvent,
    },
});

module.exports = { raManagementPlanTags };
